// 현장 설정 — 준공할 때 유지보수 기간을 두는 것을 기본으로 할지.

import { useState, useTransition } from "react";
import { toast } from "sonner";

import { InstantSaveNote } from "@/components/save-bar";
import SectionCard from "@buildpy/ui/section-card";
import { Switch } from "@buildpy/ui/switch";
import { settleRedirect } from "@/lib/redirect-error";
import { saveProjectWarrantyEnabled } from "@/api/actions/org";

interface Props {
  canEdit: boolean;
  warrantyEnabled: boolean;
}

const SettingsProject = ({ canEdit, warrantyEnabled }: Props) => {
  const [checked, setChecked] = useState(warrantyEnabled);
  const [pending, startTransition] = useTransition();

  const onChange = (next: boolean) => {
    const prev = checked;
    setChecked(next);
    startTransition(async () => {
      try {
        const result = await saveProjectWarrantyEnabled(next);
        if (result.ok) {
          toast.success(result.message);
        } else {
          setChecked(prev);
          toast.error(result.message);
        }
      } catch (caught) {
        if (settleRedirect(caught)) return;
        setChecked(prev);
        toast.error("저장하지 못했습니다. 잠시 후 다시 시도하세요.");
      }
    });
  };

  return (
    <SectionCard
      data-testid="settings-project"
      description="준공 처리할 때 먼저 골라 둘 다음 상태입니다. 현장마다 대화상자에서 바꿀 수 있습니다."
      actions={canEdit ? <InstantSaveNote /> : undefined}
      title="준공">
      <label className="flex min-h-10 items-center gap-x-2 text-sm" htmlFor="project-warranty-enabled">
        <Switch
          aria-describedby="project-warranty-enabled-label"
          aria-label="유지보수 기간 두기"
          checked={checked}
          disabled={!canEdit || pending}
          id="project-warranty-enabled"
          onCheckedChange={onChange}
        />
        <span id="project-warranty-enabled-label">{checked ? "유지보수 기간을 둡니다" : "바로 완료로 닫습니다"}</span>
      </label>
    </SectionCard>
  );
};

export default SettingsProject;
